import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { signInWithEmailAndPassword, sendPasswordResetEmail } from 'firebase/auth';
import { getFirestore, doc, updateDoc, collection, query, where, getDocs } from 'firebase/firestore';
import { auth } from '../firebase';
import './LoginScreen.css'; // Arquivo CSS para estilos
import '@fortawesome/fontawesome-free/css/all.min.css';

const LoginScreen = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [location, setLocation] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const getLocation = async () => {
      console.log('Solicitando permissão de localização...');
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            setLocation({
              latitude: position.coords.latitude,
              longitude: position.coords.longitude,
            });
            console.log('Localização obtida:', position.coords);
          },
          (error) => {
            alert('Permissão para acessar a localização foi negada');
            console.log('Permissão de localização negada', error);
          }
        );
      } else {
        alert('Geolocalização não é suportada pelo seu navegador.');
      }
    };

    getLocation();
  }, []);

  const registerForPushNotificationsAsync = async (userUid) => {
    console.log('Função de notificações push omitida na web.');
  };

  const handleLogin = () => {
    console.log('Tentando fazer login...');
    signInWithEmailAndPassword(auth, email, password)
      .then(async () => {
        const user = auth.currentUser;
        console.log('Login bem-sucedido para o usuário:', user.email);

        if (user && location) {
          console.log('Atualizando localização do usuário no Firestore...');
          const db = getFirestore();
          const cuidadoresQuery = query(collection(db, 'cuidadores'), where('email', '==', user.email));
          const cuidadoresSnapshot = await getDocs(cuidadoresQuery);

          if (!cuidadoresSnapshot.empty) {
            const cuidadorDoc = cuidadoresSnapshot.docs[0];
            const cuidadorRef = doc(db, 'cuidadores', cuidadorDoc.id);

            await updateDoc(cuidadorRef, {
              lastLocation: {
                latitude: location.latitude,
                longitude: location.longitude,
                timestamp: new Date(),
              },
            });

            console.log('Localização atualizada:', location);
          } else {
            console.log('Nenhum cuidador encontrado com o email:', user.email);
          }

          await registerForPushNotificationsAsync(user.uid);
        }

        navigate('/minha-conta'); // Alterado para redirecionar para /home após o login
      })
      .catch((error) => {
        alert(error.message);
        console.log('Erro no login:', error.message);
      });
  };

  const handleForgotPassword = () => {
    if (!email) {
      alert('Por favor, insira seu email para redefinir a senha.');
      console.log('Email não inserido para redefinição de senha.');
      return;
    }
    sendPasswordResetEmail(auth, email)
      .then(() => {
        alert('Email de redefinição de senha enviado!');
        console.log('Email de redefinição de senha enviado para:', email);
      })
      .catch((error) => {
        alert(error.message);
        console.log('Erro ao enviar email de redefinição de senha:', error.message);
      });
  };

  return (
    <div className="container">
      <img src={require('./carey-app.png')} className="logo" alt="Carey App Logo" />
      <input
        type="email"
        placeholder="Email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        className="input"
      />
      <div className="passwordContainer">
        <input
          type={showPassword ? 'text' : 'password'}
          placeholder="Senha"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="input"
        />
        <button onClick={() => setShowPassword(!showPassword)} className="eyeIcon">
          <i className={`fa ${showPassword ? 'fa-eye' : 'fa-eye-slash'}`} aria-hidden="true"></i>
        </button>
      </div>
      <button className="button" onClick={handleLogin}>
        Login
      </button>

      <button onClick={handleForgotPassword} className="forgotPassword">
        Esqueci minha senha
      </button>
      <div className="signUpContainer">
        <span className="signUpText">Ainda não tem uma Conta?</span>
        <button onClick={() => navigate('/home')} className="signUpLink">
          Cadastre-se
        </button>
      </div>
    </div>
  );
};

export default LoginScreen;


